import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgColumns3 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 3.33301V12.6663M10 3.33301V12.6663M4.13333 12.6663H11.8667C12.6134 12.6663 12.9868 12.6663 13.272 12.521C13.5229 12.3932 13.7268 12.1892 13.8547 11.9383C14 11.6531 14 11.2797 14 10.533V5.46634C14 4.7196 14 4.34624 13.8547 4.06102C13.7268 3.81014 13.5229 3.60616 13.272 3.47833C12.9868 3.33301 12.6134 3.33301 11.8667 3.33301H4.13333C3.3866 3.33301 3.01323 3.33301 2.72801 3.47833C2.47713 3.60616 2.27316 3.81014 2.14532 4.06102C2 4.34624 2 4.7196 2 5.46634V10.533C2 11.2797 2 11.6531 2.14532 11.9383C2.27316 12.1892 2.47713 12.3932 2.72801 12.521C3.01323 12.6663 3.3866 12.6663 4.13333 12.6663Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgColumns3;
